<div>
    <h1>This is external layout!</h1>
</div>
